export default __webpack_public_path__ + "static/faunus-logo-e4b0b3ce79f8fd397a7d8e80326f2f1f.jpg";